var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip } from "../..";
import { Icon } from "../../Icon";
import { AccountIndicator } from "./AccountIndicator";
export var CompanyIndicator = function (props) {
    var companyName = props.companyName;
    return (_jsx(Tooltip, { tooltipContent: companyName, children: _jsx(AccountIndicator, __assign({}, props, { children: _jsx(Icon, { source: "house", size: "medium" }) })) }));
};
